import { ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import { AccountService } from "@modules/account/services/account.service";
import { CoreModule } from "@modules/core/core.module";
import { IPantosBestAsset } from "@modules/web3/+state/web3.facade";

@Component({
	selector: "web3-remaining-asset-ui",
	imports: [CoreModule],
	templateUrl: "./remaining-asset-list.component.html",
	styleUrl: "./remaining-asset-list.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class Web3RemainingAssetListComponent {
	private accountService = inject(AccountService);

	defaultFiat = this.accountService.getDefaultFiat();
	@Input() availableAssets: IPantosBestAsset[];
}
